import React, { useEffect, useState, useCallback } from 'react';
import {
  FaInstagram, FaYoutube, FaGithub, FaTwitter, FaTwitch,
  FaDiscord, FaTiktok, FaLinkedin, FaGlobe
} from 'react-icons/fa';
import { api } from '../../utils/api';

const ICONS = {
  instagram: FaInstagram,
  youtube: FaYoutube,
  github: FaGithub,
  twitter: FaTwitter,
  twitch: FaTwitch,
  discord: FaDiscord,
  tiktok: FaTiktok,
  linkedin: FaLinkedin,
};

function isSafeUrl(u) {
  try {
    const url = new URL(u);
    return url.protocol === 'https:' || url.protocol === 'http:';
  } catch {
    return false;
  }
}

export default function SocialLinks() {
  const [links, setLinks] = useState([]);

  const load = useCallback(() => {
    api('/api/social').then(setLinks).catch(() => {});
  }, []);

  useEffect(() => {
    load();
    const handler = () => load();
    window.addEventListener('social-links-updated', handler);
    return () => window.removeEventListener('social-links-updated', handler);
  }, [load]);

  if (!links.length) return null;

  return (
    <nav className="social-links" aria-label="Social media">
      {links.map((l) => {
        const Icon = ICONS[String(l.icon).toLowerCase()] || FaGlobe;
        const url = isSafeUrl(l.url) ? l.url : '#';
        return (
          <a
            key={l._id}
            href={url}
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="social-btn"
            title={l.name}
          >
            <Icon />
            <span className="label">{l.name}</span>
          </a>
        );
      })}
    </nav>
  );
}
